
import SvgColor from '../../../components/svg-color'
import { _roles } from '../../../utils/dataDefaults'

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
)

const ICONS = {
  user: icon('ic_user'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
  clientes : icon('ic_banking'),
  subscription : icon('ic_subscription'),
  settings : icon('ic_menu_item'),
  invoice : icon('ic_invoice'),
  label : icon('ic_label'),
  ticket : icon('ic_ticket'),
  truck : icon('ic_truck'),
  cart : icon('ic_cart'),
  chef_heart : icon('ic_chef_heart'),
  shield_user : icon('ic_shield_user'),
  shop : icon('ic_shop'),
  play1 : icon('ic_play1'),
  crown_star : icon('ic_crown_star'),
  delivery : icon('ic_delivery'),
  monitor : icon('ic_monitor'),
  download: icon('ic_download'),
}

const navConfig = [
  /* INICIO (ADMIN / CLIENTE) ----------------------------------------------------------------------------------- */
  {
    subheader: 'Inicio', mod_roles : [_roles.admin, _roles.cliente],
    items: [
      { title: 'Tablero', id : 'cliente-tablero', path: '/app/tablero', icon: ICONS.monitor, mod_roles : [_roles.admin, _roles.cliente] },
      { title: 'Reportes', id : 'cliente-reportes', path: '/app/reportes', icon: ICONS.analytics, mod_roles : [_roles.admin, _roles.cliente] },
    ],
  },
  /* ------------------------------------------------------------------------------------------------------------ */
  /* OPERACION (CLIENTE) ---------------------------------------------------------------------------------------- */
  {
    subheader: 'Operación', mod_roles : [_roles.cliente],
    items: [
      { 
        title: 'Ventas', id : 'cliente-ventas', path: '/app/ventas', icon: ICONS.dashboard, mod_roles : [_roles.cliente],
        children : [
          { title: 'Panel', id : 'cliente-ventas-panel', path: '/app/ventas/panel', mod_roles : [_roles.cliente] },
          { title: 'Transacciones', id : 'cliente-ventas-pagos', path: '/app/ventas/transacciones', mod_roles : [_roles.cliente] },
          { title: 'Cortes de Caja', id : 'cliente-ventas-cortes', path: '/app/ventas/cortes', mod_roles : [_roles.cliente] },
          { title: 'Devoluciones', id : 'cliente-ventas-devoluciones', path: '/app/ventas/devoluciones', mod_roles : [_roles.cliente] },
          { title: 'Servicios Abiertos', id : 'cliente-ventas-estado-mesas', path: '/app/ventas/estado_mesas', mod_roles : [_roles.cliente] },
          { title: 'Ventas por Platillo', id : 'cliente-ventas-platillos', path: '/app/ventas/ventas_por_platillo', mod_roles : [_roles.cliente] },
        ]
      },
      { 
        title: 'Gastos', id : 'cliente-gastos', path: '/app/gastos', icon: ICONS.cart, mod_roles : [_roles.cliente],
        children : [
          { title: 'Panel', id : 'cliente-gastos-panel', path: '/app/gastos/panel', mod_roles : [_roles.cliente] },
          { title: 'Categorías', id : 'cliente-gastos-categorias', path: '/app/gastos/categorias', mod_roles : [_roles.cliente] },
          { title: 'Gastos Fijos', id : 'cliente-gastos-fijos', path: '/app/gastos/fijos', mod_roles : [_roles.cliente] },
          { title: 'Proveedores', id : 'cliente-gastos-proveedores', path: '/app/gastos/proveedores', mod_roles : [_roles.cliente] },
          { title: 'Movimientos Cuentas', id : 'cliente-gastos-movimientos-cuentas', path: '/app/gastos/movimientos_cuentas', mod_roles : [_roles.cliente] },
        ]
      },
      { 
        title: 'Facturación', id : 'cliente-facturacion', path: '/app/facturacion', icon: ICONS.invoice, mod_roles : [_roles.cliente],
        children : [
          { title: 'Comprobantes Emitidos', id : 'cliente-facturacion-emitidos', path: '/app/facturacion/emitidos', mod_roles : [_roles.cliente] },
          { title: 'Comprobantes Recibidos', id : 'cliente-facturacion-recibidos', path: '/app/facturacion/recibidos', mod_roles : [_roles.cliente] },
          { title: 'Factura Global', id : 'cliente-facturacion-global', path: '/app/facturacion/global', mod_roles : [_roles.cliente] },
          { title: 'Conexiones Sat', id : 'cliente-facturacion-conexiones-sat', path: '/app/facturacion/conexiones_sat', mod_roles : [_roles.cliente] }
        ]
      },
      { 
        title: 'Almacén', id : 'cliente-almacen', path: '/app/almacen', icon: ICONS.delivery, mod_roles : [_roles.cliente],
        children : [
          { title: 'Categorías', id : 'cliente-almacen-categorias-insumos', path: '/app/almacen/categorias', mod_roles : [_roles.cliente] },
          { title: 'Insumos', id : 'cliente-almacen-insumos', path: '/app/almacen/insumos', mod_roles : [_roles.cliente] },
          { title: 'Subrecetas', id : 'cliente-almacen-subrecetas', path: '/app/almacen/subrecetas', mod_roles : [_roles.cliente] },
          { title: 'Pedidos', id : 'cliente-almacen-pedidos', path: '/app/almacen/pedidos', mod_roles : [_roles.cliente] },
          { title: 'Traspasos', id : 'cliente-almacen-traspasos', path: '/app/almacen/traspasos', mod_roles : [_roles.cliente] },
          { title: 'Existencias', id : 'cliente-almacen-existencias', path: '/app/almacen/existencias', mod_roles : [_roles.cliente] },
        ]
      },
    ],
  },
  /* ------------------------------------------------------------------------------------------------------------- */
  /* AJUSTES (CLIENTE) ------------------------------------------------------------------------------------------- */
  {
    subheader: 'Ajustes', mod_roles : [_roles.cliente],
    items: [
      { 
        title: 'Menu', id : 'cliente-menu', path: '/app/menu', icon: ICONS.chef_heart, mod_roles : [_roles.cliente,],
        children : [
          { title: 'Categorías', id : 'cliente-menu-categorias', path: '/app/menu/categorias', mod_roles : [_roles.cliente] },
          { title: 'Platillos y Bebidas', id : 'cliente-menu-platillos', path: '/app/menu/platillos_bebidas', mod_roles : [_roles.cliente] },
          { title: 'Modificadores', id : 'cliente-menu-modificadores', path: '/app/menu/modificadores', mod_roles : [_roles.cliente] },
          { title: 'Familias Modificadores', id : 'cliente-menu-familias-modificadores', path: '/app/menu/familias_modificadores', mod_roles : [_roles.cliente] },    
          { title: 'Promociones', id : 'cliente-menu-promociones', path: '/app/menu/promociones', mod_roles : [_roles.cliente] },
          { title: 'Actualizadores Precios', id : 'cliente-menu-actualizadores-precios', path: '/app/menu/actualizadores_precios', mod_roles : [_roles.cliente] },
        ]
      },
      { 
        title: 'Usuarios', id : 'cliente-usuarios', path: '/app/usuarios', icon: ICONS.user, mod_roles : [_roles.cliente],
        children : [
          { title: 'Panel', id : 'cliente-usuarios-panel', path: '/app/usuarios/panel', mod_roles : [_roles.cliente] },
          { title: 'Permisos', id : 'cliente-usuarios-grupos', path: '/app/usuarios/permisos', mod_roles : [_roles.cliente] },
        ]
      },
      { 
        title: 'Mi Negocio', id : 'cliente-negocio', path: '/app/negocio', icon: ICONS.shop, mod_roles : [_roles.cliente],
        children : [
          { title: 'Organización', id : 'cliente-negocio-organizacion', path: '/app/negocio/organizacion', mod_roles : [_roles.cliente] },
          { title: 'Canales de Venta', id : 'cliente-negocio-canales', path: '/app/negocio/canales_ventas', mod_roles : [_roles.cliente] },
          { title: 'Formas de Pago', id : 'cliente-negocio-formas-pago', path: '/app/negocio/formas_pago', mod_roles : [_roles.cliente] },
          { title: 'Cuentas', id : 'cliente-negocio-cuentas', path: '/app/negocio/cuentas', mod_roles : [_roles.cliente] },
        ]
      },
    ],
  },
  /* ------------------------------------------------------------------------------------------------------------- */
  /* OPERACION (ADMIN) --------------------------------------------------------------------------------------- */
  {
    subheader: 'Actualizaciones',
    mod_roles: [_roles.admin],
    items: [
      { title: 'Actualizaciones', id: 'admin-actualizaciones-sucursales', path: '/app/actualizaciones_sucursales', icon: ICONS.download, mod_roles: [_roles.admin] },
    ],
  },
  /* -------------------------------------------------------------------------------------------------------------- */
  /* GESTION (ADMIN) --------------------------------------------------------------------------------------------- */
  {
    subheader: 'Gestión', mod_roles : [_roles.admin], 
    items: [
      { 
        title: 'Clientes', path: '/app/clientes', icon: ICONS.clientes, mod_roles : [_roles.admin],
        children : [
          { title: 'Panel', path: '/app/clientes/panel', mod_roles : [_roles.admin] },
          { title: 'Dispositivos', path: '/app/clientes/dispositivos', mod_roles : [_roles.admin] },
          { title: 'Tarjetas RFID', path: '/app/clientes/tarjetas_rfid', mod_roles : [_roles.admin] },
          { title: 'Contactos', path: '/app/clientes/contactos', mod_roles : [_roles.admin] },
        ]
      },
      { 
        title: 'Usuarios', path: '/app/usuarios_adm', icon: ICONS.user, mod_roles : [_roles.admin ],
        children : [
          { title: 'Panel Usuarios', path: '/app/usuarios_adm/panel', mod_roles : [_roles.admin] },
        ]
      },
      { 
        title: 'Cobranza', path: '/app/cobranza', icon: ICONS.invoice, mod_roles : [_roles.admin],
        children : [
          { title: 'Facturas', path: '/app/cobranza/facturas', mod_roles : [_roles.admin] },
          { title: 'Transacciones', path: '/app/cobranza/transacciones', mod_roles : [_roles.admin] },
          { title: 'Acumulado', path: '/app/cobranza/acumulado', mod_roles : [_roles.admin] },
        ]
      },
      { 
        title: 'Folios', path: '/app/folios', icon: ICONS.ticket, mod_roles : [_roles.admin,],
        children : [
          { title: 'Panel', path: '/app/folios/panel', mod_roles : [_roles.admin] },
          { title: 'Abonos', path: '/app/folios/abonos', mod_roles : [_roles.admin] },
        ]
      },
      { 
        title: 'Distribuidores', path: '/app/distribuidores', icon: ICONS.truck, mod_roles : [_roles.admin],
        children : [
          { title: 'Panel', path: '/app/distribuidores/panel', mod_roles : [_roles.admin] },
          { title: 'Estados de Cuenta', path: '/app/distribuidores/edos_cta', mod_roles : [_roles.admin] },
        ]
      },
    ],
  },
  /* ------------------------------------------------------------------------------------------------------------- */
  /* SISTEMA (ADMIN) --------------------------------------------------------------------------------------------- */
  {
    subheader: 'Sistema', mod_roles : [_roles.admin],
    items: [
      { 
        title: 'Ajustes', path: '/app/sistema', icon: ICONS.settings, mod_roles : [_roles.admin], 
        children: [
          { title: 'Certificado', path: '/app/sistema/certificado', mod_roles : [_roles.admin] },
        ],
      },
    ],
  },
  /* ------------------------------------------------------------------------------------------------------------ */
  /* MI CUENTA (ADMIN / CLIENTE) -------------------------------------------------------------------------------- */
  {
    subheader: 'Mi Cuenta',
    mod_roles : [_roles.admin,_roles.cliente],
    items: [
      { title: 'Mi Perfil', id : 'cliente-mi-perfil', path: '/app/mi_perfil', icon: ICONS.shield_user, mod_roles : [_roles.admin,_roles.cliente] },
      { title: 'Subscripción', id : 'cliente-subscripcion', path: '/app/subscripcion', icon: ICONS.crown_star, mod_roles : [_roles.cliente] },
      { title: 'Comprar Folios', id : 'cliente-compra-folios', path: '/app/comprar_folios', icon: ICONS.ticket, mod_roles : [_roles.cliente] },
    ],
  },
  /* ------------------------------------------------------------------------------------------------------------ */
  /* AYUDA (CLIENTE) -------------------------------------------------------------------------------------------- */
  {
    subheader: 'Ayuda',
    mod_roles : [_roles.cliente],
    items: [
      { title: 'Video Tutoriales', id : 'cliente-video-tutoriales', path: '/app/video_tutoriales', icon: ICONS.play1, mod_roles : [_roles.cliente] },
    ],
  },
  /* ------------------------------------------------------------------------------------------------------------- */
]

export default navConfig
